import {
    AlertIcon,
    notifyWithAlertOrToast,
} from "../../components/global/alert/Alert";
import t from "../../i18n/i18next";
import {
    addChemicalToReaction,
    createChemical,
    createMultiStepReaction,
    createReaction,
    deleteChemical,
    deleteMultiStepReaction,
    deleteReaction,
    removeChemicalFromReaction,
    updateChemical,
    updateMultiStepReaction,
    updateReaction,
} from "../actions/library";
import {
    createNote,
    createNoteBlock,
    createNotebook,
    deleteNote,
    deleteNoteBlock,
    deleteNotebook,
    reorderBlocks,
    updateNote,
    updateNoteBlock,
    updateNotebook,
} from "../actions/notebooks";
import {
    createAccount,
    saveOrganizationLicense,
    setOrganizationUserPassword,
    updateOrganization,
    updateOrganizationFeatures,
} from "../actions/viridischemadmin";
import { all, takeEvery } from "redux-saga/effects";
import { resolveRsaaErrorMessage } from "../utils/rsaaErrorMessage";

function* notifyMutationError(fallbackMessage: string, action: unknown) {
    const payload =
        action && typeof action === "object" && "payload" in action
            ? (action as { payload?: unknown }).payload
            : undefined;
    const message = resolveRsaaErrorMessage(payload, fallbackMessage);
    yield notifyWithAlertOrToast(t(message), t("Error"), AlertIcon.ERROR);
}

export default function* rsaaErrorNotificationsSaga() {
    yield all([
        takeEvery(createAccount.error.type, function* (action) {
            yield notifyMutationError("Failed to create trial", action);
        }),
        takeEvery(updateOrganization.error.type, function* (action) {
            yield notifyMutationError("Failed to update organization", action);
        }),
        takeEvery(saveOrganizationLicense.error.type, function* (action) {
            yield notifyMutationError("Failed to update license", action);
        }),
        takeEvery(setOrganizationUserPassword.error.type, function* (action) {
            yield notifyMutationError("Failed to set password", action);
        }),
        takeEvery(updateOrganizationFeatures.error.type, function* (action) {
            yield notifyMutationError(
                "Failed to update organization features",
                action
            );
        }),
        takeEvery(createChemical.error.type, function* (action) {
            yield notifyMutationError("Failed to create chemical", action);
        }),
        takeEvery(updateChemical.error.type, function* (action) {
            yield notifyMutationError("Failed to update chemical", action);
        }),
        takeEvery(deleteChemical.error.type, function* (action) {
            yield notifyMutationError("Failed to delete chemical", action);
        }),
        takeEvery(createReaction.error.type, function* (action) {
            yield notifyMutationError("Failed to create reaction", action);
        }),
        takeEvery(updateReaction.error.type, function* (action) {
            yield notifyMutationError("Failed to update reaction", action);
        }),
        takeEvery(deleteReaction.error.type, function* (action) {
            yield notifyMutationError("Failed to delete reaction", action);
        }),
        takeEvery(addChemicalToReaction.error.type, function* (action) {
            yield notifyMutationError(
                "Failed to add chemical to reaction",
                action
            );
        }),
        takeEvery(removeChemicalFromReaction.error.type, function* (action) {
            yield notifyMutationError(
                "Failed to remove chemical from reaction",
                action
            );
        }),
        takeEvery(createMultiStepReaction.error.type, function* (action) {
            yield notifyMutationError(
                "Failed to create multi-step reaction",
                action
            );
        }),
        takeEvery(updateMultiStepReaction.error.type, function* (action) {
            yield notifyMutationError(
                "Failed to update multi-step reaction",
                action
            );
        }),
        takeEvery(deleteMultiStepReaction.error.type, function* (action) {
            yield notifyMutationError("Failed to delete route", action);
        }),
        takeEvery(createNotebook.error.type, function* (action) {
            yield notifyMutationError("Failed to create notebook", action);
        }),
        takeEvery(updateNotebook.error.type, function* (action) {
            yield notifyMutationError("Failed to update notebook", action);
        }),
        takeEvery(deleteNotebook.error.type, function* (action) {
            yield notifyMutationError("Failed to delete notebook", action);
        }),
        takeEvery(createNote.error.type, function* (action) {
            yield notifyMutationError("Failed to create note", action);
        }),
        takeEvery(updateNote.error.type, function* (action) {
            yield notifyMutationError("Failed to update note", action);
        }),
        takeEvery(deleteNote.error.type, function* (action) {
            yield notifyMutationError("Failed to delete note", action);
        }),
        takeEvery(createNoteBlock.error.type, function* (action) {
            yield notifyMutationError("Failed to create note block", action);
        }),
        takeEvery(updateNoteBlock.error.type, function* (action) {
            yield notifyMutationError("Failed to update note block", action);
        }),
        takeEvery(deleteNoteBlock.error.type, function* (action) {
            yield notifyMutationError("Failed to delete note block", action);
        }),
        takeEvery(reorderBlocks.error.type, function* (action) {
            yield notifyMutationError("Failed to reorder blocks", action);
        }),
    ]);
}
